module.exports = __webpack_public_path__ + "img/Pattern04.e513f926.png";